import { Resources } from 'constants/resources';

import { useQuery } from '@tanstack/react-query';
import { getOrderConversion, OrderConversionRequestParams } from 'config/requests/orderConversion';
import { PERIOD_PRESETS } from 'pages/Monitoring/OrderConversion/OrderConversionList/constants/periodPresets';

export function useOrderConversion(
  params: OrderConversionRequestParams,
  refetchInterval?: number | false,
) {
  const period = PERIOD_PRESETS[params.period as keyof typeof PERIOD_PRESETS];

  return useQuery({
    queryKey: [
      Resources.OrderConversion,
      params.period,
      params.direction,
      params.merchantId,
      params?.detailed,
      params?.providerIds,
      params?.gatewayIds,
    ],
    queryFn: () => getOrderConversion({ ...params, period }),
    enabled: Boolean(params?.merchantId),
    retry: false,
    refetchInterval,
  });
}
